import { stateUi } from '@infinitro/config';
import { t, Verbiage } from '@infinitro/content';
import { formatCurrencyString, isBaseCurrencyPegged } from '@infinitro/global';
import { walletsStore } from '@infinitro/global/wallet';
import { get } from 'svelte/store';
import { replaceTranslationsVars } from './replaceVars';
const translate = get(t);
export function getNotificationUIData(notification) {
    const { notificationType, payload } = notification;
    if (!payload)
        return null;
    const useExtendedDepositTitles = get(stateUi).notifications?.useExtendedDepositNotificationTitles === true;
    const cryptoAmount = formatCurrencyString(payload.amount, payload.currency);
    const tokenUpper = payload.currency?.toUpperCase();
    let tokenDisplay = tokenUpper;
    if (payload.currency && !isBaseCurrencyPegged(payload.currency)) {
        const wallet = get(walletsStore).find((w) => w.currency === payload.currency && !w.isBonus);
        if (wallet) {
            tokenDisplay = `${tokenUpper} (${wallet.toDisplayCurrencyString(payload.amount)})`;
        }
    }
    const vars = {
        AMOUNT: cryptoAmount,
        TOKEN: tokenDisplay
    };
    const depositSuccessTitle = useExtendedDepositTitles
        ? Verbiage.custom_deposit_success_notification_title
        : Verbiage.deposit_success_notification_title;
    const depositPendingTitle = useExtendedDepositTitles
        ? Verbiage.custom_deposit_pending_notification_title
        : Verbiage.deposit_pending_notification_title;
    switch (notificationType) {
        case 'DEPOSIT': {
            const status = payload.status?.toLowerCase();
            let titleKey;
            if (status === 'completed' || status === 'ok') {
                titleKey = depositSuccessTitle;
            }
            else if (status === 'confirming') {
                titleKey = depositPendingTitle;
            }
            const translated = titleKey ? translate(titleKey) : `Deposit of ${vars.AMOUNT} ${vars.TOKEN}`;
            const title = replaceTranslationsVars(translated, vars);
            return {
                title,
                description: '',
                url: '/transactions/deposits/',
                date: payload.created_at
            };
        }
    }
}
